/* ============================================================================
   Premium storefront runtime — cart sync, drawer, wishlist, facets, slider
   File: assets/card-product-premium.js
   Load once per page, in theme.liquid <head>, with defer.
   ----------------------------------------------------------------------------
   OPTIONAL OVERRIDE — place BEFORE this script:
     <script>
       window.PC_CART_CONFIG = {
         countSelectors:  ['#cart-icon-bubble .count_item'],
         drawerSelectors: ['#CartDrawer'],
         alpineCartStores: ['xMiniCart'],
         wishlistUrl: '/pages/wishlist',
         wishlistInsertAfter: '.x-header-icon-search',
         fallbackOpenCart: false
       };
     </script>
   ========================================================================== */
(function () {
  'use strict';

  if (window.__pcRuntime) return;
  window.__pcRuntime = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var WISH_KEY = 'pc:wishlist';
  var RESET_MS = 1800;

  var CFG = Object.assign({
    countSelectors: [],
    drawerTriggers: [],
    drawerSelectors: [],
    openEvents: [],
    alpineCartStores: [],
    fallbackOpenCart: false,
    cartSectionId: 'cart-drawer',        /* section re-rendered after add */
    cartDrawerContainer: '',             /* defaults to #x-cart-drawer-container */
    wishlistUrl: ROOT + 'pages/wishlist',
    wishlistInsertAfter: '',
    wishlistAutoInject: true
  }, window.PC_CART_CONFIG || {});

  /* ==========================================================================
     SAFETY — never write text into a node that holds markup (icons live there)
     ====================================================================== */
  function isSafeCountNode(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.children.length > 0) return false;
    if (el.closest('svg')) return false;
    var t = (el.textContent || '').trim();
    return t === '' || /^\d{1,3}\+?$/.test(t);
  }

  var COUNT_SELECTORS = [
    '#cart-icon-bubble .count_item',           /* this theme */
    '.header-icon-cart .count_item',
    '[data-cart-count]', '[data-cart-item-count]', '[data-header-cart-count]',
    '.cart-count-bubble span:not(.visually-hidden)',
    '.cart-count', '#CartCount', '#cart-count', '.js-cart-count',
    '.site-header__cart-count', '.header__cart-count', '.cart-link__bubble-num'
  ].concat(CFG.countSelectors);

  var DRAWER_SELECTORS = [
    '#CartDrawer', 'cart-drawer', '#cart-drawer', '.cart-drawer',
    '[id*="cart-drawer" i]', '[class*="cart-drawer" i]', '#mini-cart', '.mini-cart'
  ].concat(CFG.drawerSelectors);

  /* Buttons only — clicking an anchor navigates the page. */
  var TRIGGER_SELECTORS = [
    '[data-cart-drawer-toggle]', '[data-open-cart]', '.js-cart-drawer-open',
    'button[aria-controls*="cart" i]', '#CartButton', '[data-action="open-cart"]'
  ].concat(CFG.drawerTriggers);

  var OPEN_EVENTS = [
    'cart:open', 'cart:refresh', 'cart:build', 'cart:updated',
    'cart-drawer:open', 'open-cart-drawer', 'ajaxProduct:added', 'product:added'
  ].concat(CFG.openEvents);

  var ALPINE_STORES = ['xMiniCart', 'xCart', 'cart', 'miniCart'].concat(CFG.alpineCartStores);

  function qsFirst(list) {
    for (var i = 0; i < list.length; i++) {
      try { var el = document.querySelector(list[i]); if (el) return el; } catch (e) {}
    }
    return null;
  }

  /* ------------------------------------------------------------ cart count -- */
  function updateCartCount(count) {
    var seen = [];
    COUNT_SELECTORS.forEach(function (sel) {
      var nodes;
      try { nodes = document.querySelectorAll(sel); } catch (e) { return; }
      Array.prototype.forEach.call(nodes, function (el) {
        if (seen.indexOf(el) > -1 || !isSafeCountNode(el)) return;
        seen.push(el);
        el.textContent = count < 100 ? String(count) : '99+';
        el.setAttribute('data-value', String(count));
        if (count > 0) {
          el.classList.remove('hidden', 'is-empty', 'opacity-0');
          el.removeAttribute('hidden');
        } else {
          el.classList.add('hidden');
        }
      });
    });
  }

  /* --------------------------------------------------------- theme handoff -- */
  function broadcast(cart, item) {
    var detail = { cart: cart, item: item, source: 'pc-card' };

    OPEN_EVENTS.forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
      window.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
    });

    try {
      if (typeof window.publish === 'function') {
        window.publish('cart-update', { source: 'pc-card', cartData: cart });
      }
    } catch (e) {}

    try {
      if (window.Alpine && window.Alpine.store) {
        ALPINE_STORES.forEach(function (key) {
          var s;
          try { s = window.Alpine.store(key); } catch (e) { return; }
          if (!s) return;
          ['refresh', 'getCart', 'fetchCart', 'getSectionCart', 'updateCart'].forEach(function (fn) {
            if (typeof s[fn] === 'function') { try { s[fn](); } catch (e) {} }
          });
          if ('itemCount' in s)  s.itemCount = cart.item_count;
          if ('item_count' in s) s.item_count = cart.item_count;
          if ('cart' in s)       s.cart = cart;
        });
      }
    } catch (e) {}
  }

  /* --------------------------------------------------------------------------
     Re-render the cart drawer.

     This theme leaves #x-cart-drawer-container EMPTY on page load and fills it
     once via:
         $store.xHeaderMenu.renderAjax($el, 'cart-drawer', '#ajax-loading-cart')
     That runs a single time. Adding through the API updates the cart on the
     server but the drawer markup stays exactly as it was rendered — which is
     why it kept saying "Your cart is empty" until a refresh.

     So after every add we re-render the 'cart-drawer' section and swap it in
     BEFORE opening the drawer.
     -------------------------------------------------------------------------- */
  function cartDrawerHost() {
    if (CFG.cartDrawerContainer) {
      var custom = document.querySelector(CFG.cartDrawerContainer);
      if (custom) return custom;
    }
    return document.getElementById('x-cart-drawer-container')
        || document.getElementById('shopify-section-cart-drawer')
        || qsFirst(DRAWER_SELECTORS);
  }

  function refreshCartDrawer() {
    var host = cartDrawerHost();
    var sectionId = CFG.cartSectionId || 'cart-drawer';
    if (!host) return Promise.resolve(false);

    return fetch(ROOT + '?section_id=' + encodeURIComponent(sectionId), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('section ' + res.status);
        return res.text();
      })
      .then(function (html) {
        if (!html || html.trim() === '') throw new Error('empty section');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.getElementById('shopify-section-' + sectionId)
                    || doc.querySelector('[id^="shopify-section-"]');

        /* Alpine 3 initialises nodes added to the DOM automatically, so a
           plain innerHTML swap is enough to revive the drawer component. */
        host.innerHTML = incoming ? incoming.innerHTML : doc.body.innerHTML;
        return true;
      })
      .catch(function (err) {
        /* fall back to the theme's own renderer */
        try {
          if (window.Alpine && window.Alpine.store) {
            var hm = window.Alpine.store('xHeaderMenu');
            if (hm && typeof hm.renderAjax === 'function') {
              hm.renderAjax(host, sectionId, '#ajax-loading-cart');
              return true;
            }
          }
        } catch (e) {}
        if (window.console) console.warn('[pc] drawer refresh failed:', err.message);
        return false;
      });
  }

  /* ==========================================================================
     FLOATING WIDGETS vs THE CART DRAWER

     Third-party chat widgets (WhatsApp, Tidio, Crisp…) are position:fixed with
     a very high z-index, so they sit on top of the drawer's checkout row on
     mobile. Out-bidding their z-index is a losing game — apps commonly use
     2147483647 — so instead they are tagged once and hidden for as long as the
     drawer is open.

     Only elements that actually compute to position:fixed are tagged, and
     anything inside the drawer is skipped, so a broad selector cannot take out
     real page content. Add your own with:
       window.PC_CART_CONFIG = { floatingWidgets: ['#my-widget'] }
     ====================================================================== */
  var FLOAT_SELECTORS = [
    '[class*="whatsapp" i]', '[id*="whatsapp" i]',
    '[class*="wa-chat" i]', '[class*="wa__" i]', '.wa-widget',
    '[class*="chat-widget" i]', '[id*="chat-widget" i]',
    '[class*="floating-button" i]', '[class*="float-btn" i]',
    '[class*="sticky-contact" i]', '[id*="contact-button" i]',
    'iframe[src*="whatsapp" i]', 'iframe[title*="chat" i]',
    '.tidio-chat', '#crisp-chatbox', '#tawkchat-container', '.zsiq_floatmain'
  ].concat(CFG.floatingWidgets || []);

  function tagFloatingWidgets() {
    var drawerSel = DRAWER_SELECTORS.join(',');
    FLOAT_SELECTORS.forEach(function (sel) {
      var nodes;
      try { nodes = document.querySelectorAll(sel); } catch (e) { return; }
      Array.prototype.forEach.call(nodes, function (el) {
        if (el.classList.contains('pc-floating-widget')) return;
        try { if (el.closest(drawerSel)) return; } catch (e) {}
        if (el.closest('[data-pc-card]')) return;        /* never a product card */
        var cs = window.getComputedStyle(el);
        if (cs.position !== 'fixed') return;
        if (el.getBoundingClientRect().width > window.innerWidth * 0.9) return;
        el.classList.add('pc-floating-widget');
      });
    });
  }

  function syncDrawerState() {
    tagFloatingWidgets();
    document.documentElement.classList.toggle('pc-drawer-open', drawerIsVisible());
  }

  /* widgets mount late and the drawer re-renders, so watch the body */
  function watchDrawerState() {
    if (!('MutationObserver' in window)) return;
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(syncDrawerState, 90);
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'open']
    });
  }

  function drawerIsVisible() {
    var d = qsFirst(DRAWER_SELECTORS);
    if (!d) return false;
    var cs = window.getComputedStyle(d);
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return false;
    return d.getBoundingClientRect().width > 40;
  }

  function openDrawer() {
    /* re-check once the drawer has painted so floating widgets clear out of
       the way of the checkout row */
    setTimeout(syncDrawerState, 60);
    setTimeout(syncDrawerState, 350);

    if (drawerIsVisible()) return;

    /* 1. this theme's Alpine mini-cart store */
    try {
      if (window.Alpine && window.Alpine.store) {
        for (var i = 0; i < ALPINE_STORES.length; i++) {
          var s;
          try { s = window.Alpine.store(ALPINE_STORES[i]); } catch (e) { continue; }
          if (!s) continue;
          if (typeof s.openCart === 'function') { s.openCart(); return; }
          if (typeof s.open === 'function')     { s.open();     return; }
          if (typeof s.show === 'function')     { s.show();     return; }
          if ('open' in s)   { s.open = true;   return; }
          if ('isOpen' in s) { s.isOpen = true; return; }
        }
      }
    } catch (e) {}

    /* 2. non-navigating trigger buttons */
    for (var t = 0; t < TRIGGER_SELECTORS.length; t++) {
      var el;
      try { el = document.querySelector(TRIGGER_SELECTORS[t]); } catch (e) { continue; }
      if (!el) continue;
      var href = el.getAttribute && el.getAttribute('href');
      if (href && href !== '#') continue;          /* never navigate */
      el.click();
      if (drawerIsVisible()) return;
    }

    /* 3. force-open the drawer element */
    var drawer = qsFirst(DRAWER_SELECTORS);
    if (drawer) {
      drawer.classList.add('is-open', 'active', 'open', 'is-active');
      drawer.removeAttribute('hidden');
      if (drawer.hasAttribute('aria-hidden')) drawer.setAttribute('aria-hidden', 'false');
      if (typeof drawer.open === 'function') { try { drawer.open(); } catch (e) {} }
      document.documentElement.classList.add('cart-drawer-open');
    }

    if (!drawerIsVisible() && CFG.fallbackOpenCart) window.location.href = ROOT + 'cart';
  }

  /* -------------------------------------------------------- button states -- */
  function setState(btn, cls, label) {
    var span = btn.querySelector('.pc-atc__label');
    if (!btn.dataset.pcLabel && span) btn.dataset.pcLabel = span.textContent;
    btn.classList.remove('is-loading', 'is-done', 'is-error');
    if (cls) btn.classList.add(cls);
    if (span && label != null) span.textContent = label;
  }
  function resetState(btn) { setState(btn, null, btn.dataset.pcLabel || null); }

  /* ----------------------------------------------------------- add to cart -- */
  document.addEventListener('submit', function (evt) {
    var form = evt.target.closest('[data-pc-form]');
    if (!form) return;

    evt.preventDefault();

    var btn = form.querySelector('[data-pc-atc]');
    if (!btn || btn.classList.contains('is-loading')) return;

    setState(btn, 'is-loading', 'Adding');

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: Number(form.querySelector('[name="id"]').value),
        quantity: Number(form.querySelector('[name="quantity"]').value || 1)
      })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Add to cart failed');
          return data;
        });
      })
      .then(function (item) {
        return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            setState(btn, 'is-done', 'Added');
            updateCartCount(cart.item_count);
            broadcast(cart, item);

            /* re-render the drawer FIRST, then open it — otherwise the
               customer sees the stale "your cart is empty" markup */
            return refreshCartDrawer().then(function () {
              openDrawer();
              setTimeout(function () { resetState(btn); }, RESET_MS);
            });
          });
      })
      .catch(function (err) {
        setState(btn, 'is-error', 'Unavailable');
        if (window.console) console.warn('[pc]', err.message);
        setTimeout(function () { resetState(btn); }, RESET_MS);
      });
  });

  /* ==========================================================================
     WISHLIST
     ====================================================================== */
  function readWishlist() {
    try {
      var raw = localStorage.getItem(WISH_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function writeWishlist(list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function updateWishCount() {
    var n = readWishlist().length;
    Array.prototype.forEach.call(document.querySelectorAll('[data-pc-wish-count]'), function (el) {
      el.textContent = n < 100 ? String(n) : '99+';
      el.setAttribute('data-value', String(n));
      if (n > 0) { el.classList.remove('hidden'); el.removeAttribute('hidden'); }
      else { el.classList.add('hidden'); }
    });
  }

  function syncWishButtons(root) {
    var list = readWishlist();
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-pc-wish]'), function (btn) {
      btn.setAttribute('aria-pressed', list.indexOf(btn.getAttribute('data-product-handle')) > -1 ? 'true' : 'false');
    });
  }

  var lastToggleBtn = null;
  var lastToggleAt = 0;

  function toggleWish(btn) {
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;

    /* the delegated and direct handlers are both live as a safety net —
       this guard makes a double fire impossible */
    var now = Date.now();
    if (btn === lastToggleBtn && now - lastToggleAt < 300) return;
    lastToggleBtn = btn;
    lastToggleAt = now;

    var list = readWishlist();
    var idx = list.indexOf(handle);

    if (idx > -1) {
      list.splice(idx, 1);
      btn.setAttribute('aria-pressed', 'false');
    } else {
      list.push(handle);
      btn.setAttribute('aria-pressed', 'true');
      btn.classList.remove('is-pop');
      void btn.offsetWidth;
      btn.classList.add('is-pop');
    }

    writeWishlist(list);
    updateWishCount();
    syncWishButtons();
    document.dispatchEvent(new CustomEvent('pc:wishlist', { bubbles: true, detail: { handle: handle, list: list } }));
  }

  /* --------------------------------------------------------------------------
     Click handling.

     Do NOT preventDefault on pointerdown/mousedown — browsers suppress the
     follow-up compatibility events, which swallows the click entirely and the
     heart never fires. Those phases only stop propagation, so the theme's own
     card handlers never see the event. The click itself is where we act.
     -------------------------------------------------------------------------- */
  function wishTarget(evt) {
    return evt.target && evt.target.closest ? evt.target.closest('[data-pc-wish]') : null;
  }

  ['pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, function (evt) {
      if (!wishTarget(evt)) return;
      evt.stopPropagation();                       /* no preventDefault here */
      if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
    }, { capture: true, passive: true });
  });

  document.addEventListener('click', function (evt) {
    var btn = wishTarget(evt);
    if (!btn) return;
    evt.preventDefault();
    evt.stopPropagation();
    if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
    toggleWish(btn);
  }, true);

  /* Belt and braces: bind straight to each button too, so the heart still works
     if a theme script cancels delegated events higher up the tree. */
  function bindWishButtons(root) {
    var nodes = (root || document).querySelectorAll('[data-pc-wish]');
    Array.prototype.forEach.call(nodes, function (btn) {
      if (btn.__pcWishBound) return;
      btn.__pcWishBound = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        toggleWish(btn);
      });
    });
  }

  /* ------------------------------ header icon (theme-native styling) ------ */
  /* Presentation attributes lose to any theme CSS rule, and most themes set
     `svg path { fill: currentColor }` — which is what turned this heart into a
     solid black blob. Inline style attributes outrank those rules. */
  var HEART_SVG =
    '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false" ' +
    'style="fill:none;stroke:currentColor;stroke-width:1.5;display:block;overflow:visible">' +
    '<path style="fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round" ' +
    'd="M12 20.1l-1.2-1.09C6 14.68 3.2 12.14 3.2 9.02 3.2 6.47 5.2 4.5 7.75 4.5c1.44 0 2.82.67 3.72 1.73L12 7.02l.53-.79c.9-1.06 2.28-1.73 3.72-1.73 2.55 0 4.55 1.97 4.55 4.52 0 3.12-2.8 5.66-7.6 9.99L12 20.1z"/>' +
    '</svg>';

  function injectWishlistIcon() {
    if (!CFG.wishlistAutoInject) return;
    if (document.querySelector('[data-pc-wishlink]')) return;   /* snippet already placed */

    var after = null;
    if (CFG.wishlistInsertAfter) {
      try { after = document.querySelector(CFG.wishlistInsertAfter); } catch (e) {}
    }
    if (!after) {
      after = document.querySelector('.x-header-icon-search')          /* this theme */
           || document.querySelector('#SearchOpen')
           || document.querySelector('header a[href*="/search"]');
      if (after && after.id === 'SearchOpen' && after.parentElement) after = after.parentElement;
    }

    var before = document.querySelector('.header-icon-account, shopify-account')
              || document.querySelector('.header-icon-cart, #cart-icon');

    var host = (after && after.parentElement) || (before && before.parentElement);
    if (!host) return;

    var link = document.createElement('a');
    link.href = CFG.wishlistUrl;
    link.className = 'relative flex items-center justify-center header-icon-wishlist cursor-pointer';
    link.setAttribute('data-pc-wishlink', '');
    link.setAttribute('aria-label', 'Wishlist');

    /* container + badge mirror the theme's own cart icon markup exactly */
    link.innerHTML =
      '<span class="relative w-11 h-10 pl-3 pr-3 pt-2.5 pb-2 inline-block">' +
        HEART_SVG +
        '<span class="count_item absolute text-center place-content-center -top-0.5 right-0 md:right-0 ' +
        'bg-[rgba(var(--colors-cart))] text-[rgba(var(--colors-cart-text))] font-medium h-5 w-5 ' +
        'rounded-full text-[9px] hidden" data-pc-wish-count data-value="0">0</span>' +
      '</span>';

    if (after && after.parentElement) after.parentElement.insertBefore(link, after.nextSibling);
    else before.parentElement.insertBefore(link, before);

    updateWishCount();
  }

  /* ------------------------------------------------------------- money ----- */
  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    function pad(n, s) { var v = String(n); while (v.length < s) v = '0' + v; return v; }
    function thousands(n, sep) { return n.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + sep); }

    var match = /\{\{\s*(\w+)\s*\}\}/.exec(fmt);
    var placeholder = match ? match[1] : 'amount';
    var num = cents / 100.0;
    var value;

    switch (placeholder) {
      case 'amount_no_decimals': value = thousands(pad(Math.round(num), 1), ','); break;
      case 'amount_with_comma_separator': value = thousands(num.toFixed(2), '.').replace(/\.(\d{2})$/, ',$1'); break;
      case 'amount_no_decimals_with_comma_separator': value = thousands(pad(Math.round(num), 1), '.'); break;
      case 'amount_with_space_separator': value = thousands(num.toFixed(2), ' ').replace(/\.(\d{2})$/, ',$1'); break;
      default: value = thousands(num.toFixed(2), ','); break;
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* -------------------------------------------------------- wishlist page -- */

  /* Price formatter that still works when the grid was auto-mounted and so
     has no shop.money_format from Liquid. */
  function priceText(cents, fmt) {
    if (fmt) return formatMoney(cents, fmt);
    try {
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
        style: 'currency', currency: cur, minimumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return formatMoney(cents, '${{amount}}');
    }
  }

  /* The wishlist page needs a container to render into. If the theme page is
     missing the Wishlist section (a banner-only template, say), mount one so
     the page still works instead of showing nothing at all. */
  function onWishlistPage() {
    try {
      var target = new URL(CFG.wishlistUrl, window.location.origin).pathname.replace(/\/$/, '');
      var here = window.location.pathname.replace(/\/$/, '');
      return here === target;
    } catch (e) { return false; }
  }

  function ensureWishlistGrid() {
    if (document.querySelector('[data-pc-wishlist-grid]')) return true;
    if (!onWishlistPage()) return false;

    var host = document.querySelector('#MainContent, main, [role="main"]');
    if (!host) return false;

    var wrap = document.createElement('div');
    wrap.className = 'pc-shell pc-shell--boxed pc-wishlist-mount';
    wrap.innerHTML =
      '<div class="pc-wishlist-grid" data-pc-wishlist-grid></div>' +
      '<div class="pc-wishlist-empty" data-pc-wishlist-empty hidden>' +
        '<p class="pc-wishlist-empty__title">Nothing saved yet</p>' +
        '<p>Tap the heart on any product to save it here.</p>' +
        '<p style="margin-top:20px">' +
          '<a href="' + ROOT + 'collections/all" class="pc-atc" style="display:inline-flex;width:auto;min-width:220px">' +
            '<span class="pc-atc__label">Browse products</span>' +
          '</a>' +
        '</p>' +
      '</div>';

    host.appendChild(wrap);
    if (window.console) {
      console.info('[pc] Wishlist section not found on this page — grid auto-mounted. ' +
                   'Add the "Wishlist" section to the page template for full control.');
    }
    return true;
  }

  /* --------------------------------------------------------------------------
     One card builder shared by the wishlist page and the recently-viewed
     section, so both stay identical to the Liquid card without duplicating it.
     -------------------------------------------------------------------------- */
  function pcCardHTML(p, money, opts) {
    opts = opts || {};
    var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]{3,4})(\?|$)/i, '_720x$1$2') : '';
    var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0];
    var sale = v && v.compare_at_price > v.price;
    var single = p.variants.length === 1;
    var url = ROOT + 'products/' + p.handle;
    var pressed = opts.wished ? 'true' : 'false';

    return '' +
      '<div class="pc-card pc-card--natural" data-product-handle="' + p.handle + '">' +
        '<div class="pc-media pc-media--natural">' +
          '<a class="pc-media__link" href="' + url + '" tabindex="-1" aria-hidden="true">' +
            (img ? '<img class="pc-media__img pc-media__img--main" src="' + img + '" alt="" loading="lazy" decoding="async">' : '') +
          '</a>' +
          '<button type="button" class="pc-wish" data-pc-wish data-product-handle="' + p.handle + '" aria-pressed="' + pressed + '" aria-label="Save">' +
            '<svg viewBox="0 0 24 24" width="19" height="19" aria-hidden="true" style="display:block;overflow:visible">' +
              '<path class="pc-wish__path" style="fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round" ' +
              'd="M12 20.1l-1.2-1.09C6 14.68 3.2 12.14 3.2 9.02 3.2 6.47 5.2 4.5 7.75 4.5c1.44 0 2.82.67 3.72 1.73L12 7.02l.53-.79c.9-1.06 2.28-1.73 3.72-1.73 2.55 0 4.55 1.97 4.55 4.52 0 3.12-2.8 5.66-7.6 9.99L12 20.1z"/>' +
            '</svg>' +
          '</button>' +
        '</div>' +
        '<div class="pc-body">' +
          '<h3 class="pc-title"><a class="pc-title__link" href="' + url + '">' + p.title + '</a></h3>' +
          '<div class="pc-foot pc-foot--inline">' +
            '<div class="pc-price' + (sale ? ' pc-price--sale' : '') + '">' +
              '<span class="pc-price__now">' + priceText(v.price, money) + '</span>' +
              (sale ? '<s class="pc-price__was">' + priceText(v.compare_at_price, money) + '</s>' : '') +
            '</div>' +
            '<div class="pc-actions">' +
              (!p.available
                ? '<button type="button" class="pc-atc is-disabled" disabled><span class="pc-atc__label">Sold out</span></button>'
                : single
                  ? '<form method="post" action="' + ROOT + 'cart/add" data-pc-form novalidate>' +
                      '<input type="hidden" name="id" value="' + v.id + '">' +
                      '<input type="hidden" name="quantity" value="1">' +
                      '<button type="submit" class="pc-atc" data-pc-atc>' +
                        '<span class="pc-atc__spinner" aria-hidden="true"></span>' +
                        '<span class="pc-atc__label">Add to cart</span>' +
                      '</button>' +
                    '</form>'
                  : '<a href="' + url + '" class="pc-atc pc-atc--ghost"><span class="pc-atc__label">Choose options</span></a>'
              ) +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function renderWishlist() {
    ensureWishlistGrid();

    var grid = document.querySelector('[data-pc-wishlist-grid]');
    if (!grid) return;

    var empty = document.querySelector('[data-pc-wishlist-empty]');
    var money = grid.getAttribute('data-money-format') || null;
    var list = readWishlist();

    if (!list.length) {
      grid.innerHTML = '';
      if (empty) empty.removeAttribute('hidden');
      return;
    }
    if (empty) empty.setAttribute('hidden', '');

    Promise.all(list.map(function (handle) {
      return fetch(ROOT + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var valid = products.filter(Boolean);

      if (!valid.length) {
        grid.innerHTML = '';
        if (empty) empty.removeAttribute('hidden');
        return;
      }

      var markup = valid.map(function (p) {
        return pcCardHTML(p, money, { wished: true });
      }).join('');

      grid.innerHTML = markup;
      bindWishButtons(grid);
    });
  }

  document.addEventListener('pc:wishlist', function () { renderWishlist(); });

  /* ==========================================================================
     RECENTLY VIEWED — self-contained

     The theme's own version renders `search.results` server-side and relies on
     its Alpine store re-fetching the section. When that chain doesn't fire the
     heading shows with no products under it. This engine owns the whole thing:
     handles are kept in localStorage and products are fetched from the public
     /products/<handle>.js endpoint, exactly like the wishlist page.
     ====================================================================== */
  var RECENT_KEY = 'pc:recent';
  var RECENT_MAX = 24;

  function readRecent() {
    try {
      var raw = localStorage.getItem(RECENT_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function writeRecent(list) {
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {}
  }

  /* record the product currently being viewed, newest first, no duplicates */
  function trackRecent() {
    var node = document.querySelector('[data-pc-recent-track]');
    if (!node) return;
    var handle = node.getAttribute('data-pc-recent-track');
    if (!handle) return;

    var list = readRecent().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    writeRecent(list.slice(0, RECENT_MAX));
  }

  function renderRecent() {
    var grid = document.querySelector('[data-pc-recent-grid]');
    if (!grid) return;

    var section = document.querySelector('[data-pc-recent-section]');
    var exclude = grid.getAttribute('data-exclude') || '';
    var limit = parseInt(grid.getAttribute('data-limit'), 10) || 4;
    var money = grid.getAttribute('data-money-format') || null;

    var list = readRecent()
      .filter(function (h) { return h && h !== exclude; })
      .slice(0, limit);

    /* nothing viewed yet — keep the whole section out of the page */
    if (!list.length) {
      if (section && !section.hasAttribute('data-pc-keep')) section.hidden = true;
      return;
    }

    Promise.all(list.map(function (handle) {
      return fetch(ROOT + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var wish = readWishlist();
      var valid = products.filter(Boolean);

      if (!valid.length) {
        if (section && !section.hasAttribute('data-pc-keep')) section.hidden = true;
        return;
      }

      grid.innerHTML = valid.map(function (p) {
        return pcCardHTML(p, money, { wished: wish.indexOf(p.handle) > -1 });
      }).join('');

      if (section) section.hidden = false;
      bindWishButtons(grid);
      syncWishButtons(grid);
    });
  }

  /* "Clear history" */
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest ? evt.target.closest('[data-pc-recent-clear]') : null;
    if (!btn) return;
    evt.preventDefault();
    writeRecent([]);
    var section = document.querySelector('[data-pc-recent-section]');
    var grid = document.querySelector('[data-pc-recent-grid]');
    if (grid) grid.innerHTML = '';
    if (section && !section.hasAttribute('data-pc-keep')) section.hidden = true;
  });

  /* ==========================================================================
     FACETS — auto-submit, dual-handle price slider, mobile drawer
     ====================================================================== */
  var facetTimer = null;
  var facetAbort = null;
  var GRID_ID = 'ProductGridContainer';

  function formToUrl(form) {
    var params = new URLSearchParams(new FormData(form));
    var clean = new URLSearchParams();
    params.forEach(function (val, key) { if (String(val).trim() !== '') clean.append(key, val); });
    var qs = clean.toString();
    return form.getAttribute('action') + (qs ? '?' + qs : '');
  }

  /* remember which accordions are open, and where the panel is scrolled */
  function captureUi(root) {
    var state = { open: {}, scroll: 0 };
    if (!root) return state;
    var panel = root.querySelector('.pcf__panel');
    if (panel) state.scroll = panel.scrollTop;
    state.expanded = {};
    Array.prototype.forEach.call(root.querySelectorAll('details.pcf__group'), function (d, i) {
      var s = d.querySelector('.pcf__summary > span');
      var key = s ? s.textContent.trim() : 'g' + i;
      state.open[key] = d.open;
      state.expanded[key] = d.classList.contains('is-expanded');
    });
    return state;
  }

  function restoreUi(root, state) {
    if (!root || !state) return;
    Array.prototype.forEach.call(root.querySelectorAll('details.pcf__group'), function (d, i) {
      var s = d.querySelector('.pcf__summary > span');
      var key = s ? s.textContent.trim() : 'g' + i;
      if (key in state.open) d.open = state.open[key];
      if (state.expanded && state.expanded[key]) {
        d.classList.add('is-expanded');
        var mb = d.querySelector('[data-pc-more]');
        if (mb) mb.setAttribute('aria-expanded', 'true');
      }
    });
    var panel = root.querySelector('.pcf__panel');
    if (panel && state.scroll) panel.scrollTop = state.scroll;
  }

  function setBusy(on) {
    var grid = document.getElementById(GRID_ID);
    var side = document.querySelector('[data-pc-filter-col]');
    if (grid) grid.classList.toggle('pc-busy', on);
    if (side) side.classList.toggle('pc-busy', on);
  }

  /* --------------------------------------------------------------------------
     AJAX facets: fetch the filtered collection, swap the grid and the sidebar,
     push the new URL. No page reload, scroll position kept.
     -------------------------------------------------------------------------- */
  function loadFacets(url, push) {
    var grid = document.getElementById(GRID_ID);
    var side = document.querySelector('[data-pc-filter-col]');
    if (!grid) { window.location.href = url; return; }

    if (facetAbort && facetAbort.abort) { try { facetAbort.abort(); } catch (e) {} }
    facetAbort = ('AbortController' in window) ? new AbortController() : null;

    var ui = captureUi(side);
    var wasOpen = side ? side.classList.contains('is-open') : false;

    setBusy(true);

    fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: facetAbort ? facetAbort.signal : undefined
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var nextGrid = doc.getElementById(GRID_ID);
        if (!nextGrid) throw new Error('grid missing in response');
        grid.innerHTML = nextGrid.innerHTML;

        var nextSide = doc.querySelector('[data-pc-filter-col]');
        if (nextSide && side) {
          side.innerHTML = nextSide.innerHTML;
          side.classList.toggle('is-open', wasOpen);
          restoreUi(side, ui);
        }

        if (push !== false) history.pushState({ pcFacets: true }, '', url);

        if (doc.title) document.title = doc.title;

        syncWishButtons(grid);
        bindWishButtons(grid);
        initSliders(document);
        watchInfinite();          /* the load-more block was just replaced */
        setBusy(false);

        /* only scroll if the results scrolled out of view above */
        var top = grid.getBoundingClientRect().top;
        if (top < 0) window.scrollTo({ top: window.scrollY + top - 24, behavior: 'smooth' });
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        setBusy(false);
        if (window.console) console.warn('[pc] facet load failed, falling back', err.message);
        window.location.href = url;              /* never leave the user stuck */
      });
  }

  function submitFacets(form) {
    if (!form) return;
    clearTimeout(facetTimer);
    facetTimer = setTimeout(function () { loadFacets(formToUrl(form), true); }, 240);
  }

  document.addEventListener('change', function (evt) {
    var el = evt.target;

    var sortForm = el.closest ? el.closest('[data-pc-sort-form]') : null;
    if (sortForm && el.name === 'sort_by') {
      evt.preventDefault();
      loadFacets(formToUrl(sortForm), true);
      return;
    }

    var form = el.closest ? el.closest('[data-pc-facet-form]') : null;
    if (!form) return;
    if (el.type === 'range') return;               /* slider commits itself */
    if (el.type === 'checkbox' || el.name === 'sort_by') submitFacets(form);
  });

  /* "Clear all", active chips and collection links go through AJAX too */
  document.addEventListener('click', function (evt) {
    var a = evt.target.closest ? evt.target.closest('.pcf__clear, .pcf__chip') : null;
    if (!a || !a.getAttribute('href')) return;
    if (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.button) return;
    evt.preventDefault();
    loadFacets(a.href, true);
  });

  /* back / forward */
  window.addEventListener('popstate', function (evt) {
    if (!evt.state || !evt.state.pcFacets) return;
    loadFacets(window.location.href, false);
  });

  /* ------------------------------------------------------- price slider --- */
  function initSliders(root) {
    var nodes = (root || document).querySelectorAll('[data-pc-slider]');
    Array.prototype.forEach.call(nodes, function (sl) {
      if (sl.__pcInit) return;
      sl.__pcInit = true;

      var lo = parseFloat(sl.getAttribute('data-min')) || 0;
      var hi = parseFloat(sl.getAttribute('data-max')) || 0;
      var prefix = sl.getAttribute('data-prefix') || '';

      var rMin = sl.querySelector('[data-pc-slider-range="min"]');
      var rMax = sl.querySelector('[data-pc-slider-range="max"]');
      var fill = sl.querySelector('[data-pc-slider-fill]');
      var lMin = sl.querySelector('[data-pc-slider-label="min"]');
      var lMax = sl.querySelector('[data-pc-slider-label="max"]');
      var fMin = sl.querySelector('[data-pc-slider-field="min"]');
      var fMax = sl.querySelector('[data-pc-slider-field="max"]');
      if (!rMin || !rMax) return;

      function fmt(n) {
        var s = String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return prefix + s;                          /* prefix already ends in a space */
      }

      function paint() {
        var a = Math.min(+rMin.value, +rMax.value);
        var b = Math.max(+rMin.value, +rMax.value);
        var span = (hi - lo) || 1;
        if (fill) {
          fill.style.left = ((a - lo) / span * 100) + '%';
          fill.style.right = (100 - (b - lo) / span * 100) + '%';
        }
        if (lMin) lMin.textContent = fmt(a);
        if (lMax) lMax.textContent = fmt(b);
      }

      function commit() {
        var a = Math.min(+rMin.value, +rMax.value);
        var b = Math.max(+rMin.value, +rMax.value);
        if (fMin) fMin.value = a > lo ? a : '';
        if (fMax) fMax.value = b < hi ? b : '';
        submitFacets(sl.closest('[data-pc-facet-form]'));
      }

      rMin.addEventListener('input', function () {
        if (+rMin.value > +rMax.value) rMin.value = rMax.value;
        paint();
      });
      rMax.addEventListener('input', function () {
        if (+rMax.value < +rMin.value) rMax.value = rMin.value;
        paint();
      });
      rMin.addEventListener('change', commit);
      rMax.addEventListener('change', commit);

      paint();
    });
  }

  /* ==========================================================================
     LOAD MORE / INFINITE SCROLL

     The button holds the next page's URL. We fetch that page, move its
     #items-grid children into the live grid, then read the next URL out of the
     response so the button keeps walking forward. Nothing is re-rendered, so
     scroll position and everything already on screen stay put.
     ====================================================================== */
  var moreBusy = false;

  function loadMore(btn) {
    if (!btn || moreBusy) return;
    var url = btn.getAttribute('data-next-url');
    if (!url) return;

    moreBusy = true;
    btn.classList.add('is-loading');
    btn.disabled = true;

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = document.getElementById('items-grid');
        var next = doc.getElementById('items-grid');
        if (!grid || !next) throw new Error('grid missing');

        var frag = document.createDocumentFragment();
        var added = [];
        Array.prototype.slice.call(next.children).forEach(function (child) {
          added.push(child);
          frag.appendChild(child);
        });
        grid.appendChild(frag);

        /* advance or retire the button */
        var nextBtn = doc.querySelector('[data-pc-loadmore]');
        var nextUrl = nextBtn && nextBtn.getAttribute('data-next-url');
        if (nextUrl) {
          btn.setAttribute('data-next-url', nextUrl);
        } else {
          btn.remove();
        }

        /* progress readout */
        var shownFrom = doc.querySelector('[data-pc-shown]');
        var shownHere = document.querySelector('[data-pc-shown]');
        if (shownFrom && shownHere) shownHere.textContent = shownFrom.textContent;

        var fillFrom = doc.querySelector('.pcmore__rail-fill');
        var fillHere = document.querySelector('.pcmore__rail-fill');
        if (fillFrom && fillHere) fillHere.style.width = fillFrom.style.width;

        /* keep the URL shareable without adding history entries */
        try { history.replaceState({ pcFacets: true }, '', url); } catch (e) {}

        added.forEach(function (el) { syncWishButtons(el); bindWishButtons(el); });

        btn.classList.remove('is-loading');
        btn.disabled = false;
        moreBusy = false;
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        moreBusy = false;
        if (window.console) console.warn('[pc] load more failed', err.message);
        window.location.href = url;          /* never strand the customer */
      });
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest ? evt.target.closest('[data-pc-loadmore]') : null;
    if (!btn) return;
    evt.preventDefault();
    loadMore(btn);
  });

  /* infinite scroll: same machinery, triggered by the button entering view */
  var autoObserver = null;
  function watchInfinite() {
    var wrap = document.querySelector('[data-pc-more-wrap][data-pc-auto="true"]');
    if (!wrap || !('IntersectionObserver' in window)) return;
    if (autoObserver) autoObserver.disconnect();

    autoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var btn = document.querySelector('[data-pc-loadmore]');
        if (btn) loadMore(btn);
      });
    }, { rootMargin: '400px 0px' });

    autoObserver.observe(wrap);
  }

  /* ------------------------------------------- "Show N more" in a filter -- */
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest ? evt.target.closest('[data-pc-more]') : null;
    if (!btn) return;
    evt.preventDefault();
    var group = btn.closest('.pcf__group');
    if (!group) return;
    var on = group.classList.toggle('is-expanded');
    btn.setAttribute('aria-expanded', on ? 'true' : 'false');
  });

  /* --------------------------------------------------- mobile filter drawer */
  document.addEventListener('click', function (evt) {
    var open = evt.target.closest ? evt.target.closest('[data-pc-filter-open]') : null;
    var close = evt.target.closest ? evt.target.closest('[data-pc-filter-close]') : null;
    if (!open && !close) return;
    evt.preventDefault();
    var col = document.querySelector('[data-pc-filter-col]');
    if (!col) return;
    col.classList.toggle('is-open', !!open);
    document.documentElement.style.overflow = open ? 'hidden' : '';
  });

  /* --------------------------------------------------------------- boot ---- */
  function boot() {
    syncWishButtons();
    bindWishButtons();
    injectWishlistIcon();
    updateWishCount();
    renderWishlist();
    trackRecent();          /* record before rendering, so "exclude" works */
    renderRecent();
    initSliders();
    watchInfinite();
    watchHeader();
    syncDrawerState();
    watchDrawerState();

    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (cart && typeof cart.item_count === 'number') updateCartCount(cart.item_count); })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* --------------------------------------------------------------------------
     This theme builds parts of the header with
     `$store.xHeaderMenu.renderAjax(...)`, which replaces markup after load and
     again on cart updates. Poll briefly for the first mount, then watch the
     header so the icon is restored if a re-render wipes it.
     -------------------------------------------------------------------------- */
  var tries = 0;
  var late = setInterval(function () {
    if (++tries > 20 || document.querySelector('[data-pc-wishlink]')) { clearInterval(late); return; }
    injectWishlistIcon();
  }, 300);

  function watchHeader() {
    var header = document.querySelector('header, .x-header, #shopify-section-header, [id*="section-header" i]');
    if (!header || !('MutationObserver' in window)) return;
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () {
        if (!document.querySelector('[data-pc-wishlink]')) injectWishlistIcon();
        updateWishCount();
      }, 120);
    }).observe(header, { childList: true, subtree: true });
  }

  /* keep every open tab in sync */
  window.addEventListener('storage', function (e) {
    if (e.key !== WISH_KEY) return;
    updateWishCount();
    syncWishButtons();
    renderWishlist();
  });

  /* bfcache restores (back button) fire pageshow, not DOMContentLoaded */
  window.addEventListener('pageshow', function () {
    updateWishCount();
    syncWishButtons();
  });

  /* re-sync after AJAX filtering / infinite scroll */
  var pgc = document.getElementById('ProductGridContainer');
  if (pgc && 'MutationObserver' in window) {
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(function () { syncWishButtons(pgc); bindWishButtons(pgc); initSliders(pgc); }, 80);
    }).observe(pgc, { childList: true, subtree: true });
  }

  window.PCRuntime = {
    getWishlist: readWishlist,
    clearWishlist: function () { writeWishlist([]); updateWishCount(); syncWishButtons(); renderWishlist(); },
    refreshCartCount: function () {
      return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { updateCartCount(c.item_count); return c; });
    },
    openDrawer: openDrawer,
    refreshCartDrawer: refreshCartDrawer,
    getRecent: readRecent,
    clearRecent: function () { writeRecent([]); renderRecent(); },
    injectWishlistIcon: injectWishlistIcon,

    /* Paste PCRuntime.diagnose() in the console to see what is and isn't wired. */
    diagnose: function () {
      var out = {
        scriptLoaded: true,
        wishlistSaved: readWishlist(),
        headerIconFound: !!document.querySelector('[data-pc-wishlink]'),
        headerBadgeFound: !!document.querySelector('[data-pc-wish-count]'),
        cardHeartsOnPage: document.querySelectorAll('[data-pc-wish]').length,
        cartCountNodes: 0,
        drawerFound: !!qsFirst(DRAWER_SELECTORS),
        drawerHostFound: !!cartDrawerHost(),
        cartSectionId: CFG.cartSectionId || 'cart-drawer',
        alpineMiniCart: !!(window.Alpine && window.Alpine.store && window.Alpine.store('xMiniCart')),
        onWishlistPage: onWishlistPage(),
        wishlistUrl: CFG.wishlistUrl,
        wishlistGridFound: !!document.querySelector('[data-pc-wishlist-grid]')
      };
      COUNT_SELECTORS.forEach(function (s) {
        try { out.cartCountNodes += document.querySelectorAll(s).length; } catch (e) {}
      });
      if (window.console && console.table) console.table(out);
      return out;
    }
  };
})();